<script setup lang="ts" generic="T extends AcceptableValue = AcceptableValue">
import type { AcceptableValue } from 'reka-ui'
import { ListboxVirtualizer } from 'reka-ui'

defineProps<{
  options: T[]
  overscan?: number
  estimateSize?: number
  textContent?: (option: T) => string
}>()

defineSlots<{
  default?: (props: { option: T }) => unknown
}>()
</script>

<template>
  <ListboxVirtualizer :options="options" :overscan="overscan" :estimate-size="estimateSize" :text-content="textContent">
    <template #default="{ option }">
      <slot :option="option" />
    </template>
  </ListboxVirtualizer>
</template>
